import type { FilterSection } from "@/types/filterTypes";
import countryOptions from "@/utils/constants/countriesOptions";

export const useMembersFilterSections = (): FilterSection[] => {
  return [
    {
      key: "countryId",
      label: "Country",
      type: "select",
      placeholder: "Select Country",
      options: countryOptions
    },
    {
      key: "searchBy",
      label: "Search",
      type: "text",
      placeholder: "Search by name or keyword"
    },
    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
